<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">Send Announcements</h3>
    </div>
  </div>
  <form class="form" [formGroup]="sendMessageForm" autocomplete="off">
    <div class="navi-hover scroll card-body" [perfectScrollbar]="{ wheelPropagation: false }">
      <mat-form-field appearance="fill" class="mat-form-field-fluid">
        <mat-label>Received App</mat-label>
        <mat-select formControlName="received" multiple (selectionChange)="refreshContactList()">
          <mat-option *ngFor="let app of apps" [value]="app.id"> {{ app.name }} </mat-option>
        </mat-select>
        <mat-error *ngIf="isControlHasError('received', 'required')"> Required field </mat-error>
      </mat-form-field>
      <mat-form-field appearance="fill" class="mat-form-field-fluid">
        <mat-label>Select an option</mat-label>
        <mat-select [(value)]="isFromTemplate" (selectionChange)="setValidators()">
          <mat-option [value]="false">Send Notifications</mat-option>
          <mat-option [value]="true">Send Alert</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="fill" class="mat-form-field-fluid" *ngIf="isFromTemplate">
        <mat-label>{{ 'TASK.ENTITY_TYPE' | translate }}</mat-label>
        <mat-select
          formControlName="entityType"
          [(value)]="selected"
          (selectionChange)="change(selected)"
        >
          <mat-option value="CONTACT">{{ 'MENU.CONTACT' | translate }}</mat-option>
          <mat-option value="FACILITY_CONTACT">{{
            'MENU.FACILITY_CONTACTS' | translate
          }}</mat-option>
          <mat-option value="MOBILE_CONTACT">{{ 'MENU.MOBILE_CONTACTS' | translate }}</mat-option>
          <mat-option value="PATIENT_CONTACT">{{ 'MENU.PATIENT' | translate }}</mat-option>
        </mat-select>
        <mat-error *ngIf="isControlHasError('entityType', 'required')">
          {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
        </mat-error>
      </mat-form-field>
      <kt-general-autocomplete
        *ngIf="
          sendMessageForm.get('entityType').value &&
          selectedEntity !== 'MOBILE_CONTACT' &&
          isFromTemplate
        "
        [appearance]="'fill'"
        [label]="'Entity'"
        [loadItemsFunction]="entityAutocompleteCall"
        [optionSearchFields]="entitySearchFields"
        [optionHeader]="stringUtils.getEntityHeader(entityTypeBS | async)"
        [chipOptionFormatter]="stringUtils.autocompleteEntityFormatter"
        [optionFormatter]="stringUtils.autocompleteEntityFormatter"
        [valueFormatter]="stringUtils.displayName"
        [required]="true"
        [readOnly]="false"
        [control]="sendMessageForm.get('entities')"
        [change]="onEntityChange.bind(this)"
        [dataPath]="'data'"
        [placeholder]="'Select Entities'"
        [formatNewObjectFn]="formatNewEntityFn"
        [chipList]="true"
        [objects]="sendMessageForm.get('entities').value"
        #entityAutocomplete
      ></kt-general-autocomplete>
      <mat-form-field
        appearance="fill"
        class="mat-form-field-fluid"
        *ngIf="
          isFromTemplate &&
          sendMessageForm.get('entities').value &&
          (selectedEntity === 'FACILITY_CONTACT' || selectedEntity === 'PATIENT_CONTACT')
        "
      >
        <mat-label>Send To</mat-label>
        <mat-select
          formControlName="sendToEntity"
          [(value)]="selectedTo"
          (selectionChange)="onChange(selectedTo)"
        >
          <mat-option value="All">All Contacts</mat-option>
          <mat-option value="Specific">Specific Contacts</mat-option>
        </mat-select>
        <mat-error *ngIf="isControlHasError('sendToEntity', 'required')">
          {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
        </mat-error>
      </mat-form-field>
      <kt-general-autocomplete
        *ngIf="
          isFromTemplate &&
          selectedToEntity === 'Specific' &&
          (selectedEntity === 'FACILITY_CONTACT' || selectedEntity === 'PATIENT_CONTACT')
        "
        [appearance]="'fill'"
        [label]="'To Entity'"
        [loadItemsFunction]="toEntityAutocompleteCall"
        [optionSearchFields]="toEntitySearchFields"
        [optionHeader]="stringUtils.getEntityHeader(sendToEntityBS | async)"
        [chipOptionFormatter]="stringUtils.autocompleteEntityFormatter"
        [optionFormatter]="stringUtils.autocompleteEntityFormatter"
        [valueFormatter]="stringUtils.displayName"
        [required]="true"
        [readOnly]="false"
        [control]="sendMessageForm.get('toEntities')"
        [change]="onToEntityChange.bind(this)"
        [dataPath]="'data'"
        [placeholder]="'Select Entities'"
        [formatNewObjectFn]="formatNewEntityFn"
        [chipList]="true"
        #toEntityAutocomplete
      ></kt-general-autocomplete>
      <mat-form-field class="mat-form-field-fluid" appearance="fill">
        <mat-label>{{ 'EMAIL_FAX.SUBJECT' | translate }}</mat-label>
        <input matInput formControlName="subject" />
        <mat-error *ngIf="isControlHasError('subject', 'required')">
          {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
        </mat-error>
        <mat-error *ngIf="whiteSpace">
          {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
        </mat-error>
      </mat-form-field>
      <div class="mat-form-field-fluid">
        <quill-editor
          formControlName="body"
          [modules]="editorOptions"
          [styles]="editorStyle"
        ></quill-editor>
        <div style="display: flex; justify-content: space-between">
          <div>
            <span
              *ngIf="isControlHasError('body', 'required')"
              style="color: red; font-size: 10px; padding-left: 7px"
              >Value is required</span
            >
            <span
              *ngIf="textLength !== 0 && textLength < 3"
              style="color: red; font-size: 10px; padding-left: 7px"
              >{{ 'AUTH.VALIDATION.MIN_LENGTH_FIELD' | translate }} 3</span
            >
            <span
              *ngIf="textLength !== 0 && textLength > 500"
              style="color: red; font-size: 10px; padding-left: 7px"
              >{{ 'AUTH.VALIDATION.MAX_LENGTH_FIELD' | translate }} 500</span
            >
          </div>
          <div>{{ countTextLength(sendMessageForm.get('body').value) }}/500</div>
        </div>
      </div>
    </div>
  </form>
  <div class="card-footer">
    <div class="d-flex justify-content-between">
      <div class="mr-2"></div>
      <div>
        <button mat-button (click)="dialogRef.close()">Cancel</button>
        <button mat-raised-button color="primary" (click)="submit()">Submit</button>
      </div>
    </div>
  </div>
</div>
